import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface AccountState {
  loading: boolean;
  isAdding: boolean;
  categories: any[];
}

const initialState: AccountState = {
  loading: false,
  isAdding: true,
  categories: [],
};

export const categoriesSlice = createSlice({
  name: "accont",
  initialState,
  reducers: {
    getCategories: (state, action) => {
      state.loading = true;
    },
    getCategoriesSuccess: (state, action) => {
      state.loading = false;
      state.categories = action.payload.categories;
    },
    getCategoriesFaild: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.categories = [];
    },
    addCategories: (state, action) => {
      state.isAdding = true;
    },
    addCategoriesSuccess: (state, action) => {
      state.isAdding = false;
    },
    addCategoriesFaild: (state, action: PayloadAction<string>) => {
      state.isAdding = false;
    },
  },
});

export const {
  getCategories,
  getCategoriesSuccess,
  getCategoriesFaild,
  addCategories,
  addCategoriesSuccess,
  addCategoriesFaild,
} = categoriesSlice.actions;

export default categoriesSlice.reducer;
